module.exports = __webpack_public_path__ + "img/file-earmark-lock.7de2d678.svg";